module.exports = __webpack_public_path__ + "img/3-star.68b43874.png";